// extracted by mini-css-extract-plugin
export default {"banana":"Banana_banana__xVOvg"};